/**
 * Deterministic, reproducible shuffling — see docs/adr/0009.
 *
 * Lifted verbatim out of `maxDiffUtils.ts` so choice-order randomisation uses the same shuffle
 * rather than growing a second one that drifts from it.
 */

export function createPRNG(seed: number) {
  const a = 1664525;
  const c = 1013904223;
  const m = 2 ** 32;

  return function () {
    seed = (a * seed + c) % m;
    return seed / m;
  };
}

export function stringToSeed(str: string): number {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return hash >>> 0;
}

export function seededShuffle<T>(array: T[], seed: number): T[] {
  const prng = createPRNG(seed);
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(prng() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
